import { RefObject, useLayoutEffect } from "react";

export function useHorizontalScrollSync<T>(
  aRef: RefObject<HTMLElement | null>,
  bRef: RefObject<HTMLElement | null>,
  deps?: T,
) {
  useLayoutEffect(() => {
    const a = aRef.current;
    const b = bRef.current;
    if (!a || !b) return;

    let lock = false;

    const sync = (from: HTMLElement, to: HTMLElement) => () => {
      if (lock) return;
      lock = true;
      to.scrollLeft = from.scrollLeft;

      queueMicrotask(() => {
        lock = false;
      });
    };

    const syncAtoB = sync(a, b);
    const syncBtoA = sync(b, a);

    a.addEventListener("scroll", syncAtoB, { passive: true });
    b.addEventListener("scroll", syncBtoA, { passive: true });

    return () => {
      a.removeEventListener("scroll", syncAtoB);
      b.removeEventListener("scroll", syncBtoA);
    };
  }, [aRef, bRef, deps]);
}
